import { render, staticRenderFns } from "./RoleModal.vue?vue&type=template&id=e8d0d88c&scoped=true"
import script from "./RoleModal.vue?vue&type=script&lang=js"
export * from "./RoleModal.vue?vue&type=script&lang=js"
import style0 from "./RoleModal.vue?vue&type=style&index=0&id=e8d0d88c&prod&scoped=true&lang=scss"
import style1 from "./RoleModal.vue?vue&type=style&index=1&id=e8d0d88c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8d0d88c",
  null
  
)

export default component.exports